import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getDatabase } from 'firebase/database';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD5DFQ8a67kpSpa7le8SGh-TYKbx2oB26U",
  authDomain: "lynces-5aba0.firebaseapp.com",
  projectId: "lynces-5aba0",
  storageBucket: "lynces-5aba0.firebasestorage.app",
  messagingSenderId: "214094968951",
  appId: "1:214094968951:web:6d1d874f9bbef13ff62e72",
  measurementId: "G-PW69C2Q7D7",
  databaseURL: "https://lynces-5aba0-default-rtdb.europe-west1.firebasedatabase.app",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Määrittele Firebase-palvelut
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "us-central1");
export const realtimeDb = getDatabase(app); 

export default app;
